<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M20,10.0010584 C20,15.5235307 15.5235307,20 10.0007056,20 C4.47646934,20 0,15.5235307 0,10.0010584 C0,4.47646934 4.47646934,0 10.0007056,0 C15.5235307,0 20,4.47646934 20,10.0010584 L20,10.0010584 Z"
        id="path-1"
      />
    </defs>
    <g id="Add-Course-Engagement" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Catalogue-Home-" transform="translate(-75.000000, -2319.000000)">
        <g id="canada" transform="translate(75.000000, 2319.000000)">
          <mask id="mask-2" fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g id="Clip-716" />
          <polygon
            id="Fill-715"
            fill="#FFFFFF"
            mask="url(#mask-2)"
            points="3.75 20 16.25 20 16.25 0 3.75 0"
          />
          <polygon
            id="Fill-717"
            fill="#EB0000"
            mask="url(#mask-2)"
            points="16.25 20 20 20 20 0 16.25 0"
          />
          <polygon
            id="Fill-718"
            fill="#EB0000"
            mask="url(#mask-2)"
            points="0 20 3.75 20 3.75 0 0 0"
          />
          <path
            d="M16.25,10.6521836 C15.1594577,10.4001477 15.6254538,9.90446572 15.8007129,8.59663057 C13.9697752,8.87048058 13.7685243,9.04398604 13.8854875,7.92073116 C13.3114397,8.39090746 12.690978,9.46180866 12.2405769,9.75982191 C11.9294178,9.97997584 11.8722358,9.73465187 11.9416711,9.57020762 C12.0103637,9.40576338 12.8814608,7.70460444 12.9883986,6.73069178 C11.9665489,7.3404779 11.526916,6.92768928 10.625,5 C9.72308403,6.92768928 9.28382236,7.3404779 8.26160143,6.73069178 C8.36853918,7.70460444 9.23889366,9.40576338 9.30870024,9.57020762 C9.37813552,9.73465187 9.32058222,9.97997584 9.00868044,9.75982191 C8.55902205,9.46180866 7.9385603,8.39090746 7.3641412,7.92073116 C7.48147567,9.04398604 7.28022477,8.87048058 5.44928708,8.59663057 C5.62380355,9.90446572 6.09054228,10.4001477 5,10.6521836 C7.60066671,12.75707 7.79226352,12.9550743 6.76484421,13.8971049 C8.90471318,13.6813138 10.3565417,13.193015 10.3565417,13.193015 C10.4957836,13.1487158 10.465336,13.2618131 10.465336,13.3769241 L10.3829048,16.25 L10.625,16.2486576 L10.8674665,16.25 L10.7839214,13.3769241 C10.7839214,13.2618131 10.7534738,13.1487158 10.8923444,13.193015 C10.8923444,13.193015 12.3452868,13.6813138 14.4844132,13.8971049 C13.4581078,12.9550743 13.6493333,12.75707 16.25,10.6521836"
            id="Fill-719"
            fill="#EB0000"
            mask="url(#mask-2)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "canada",
};
</script>

<style scoped>
</style>
